export default __webpack_public_path__ + "static/15-hacker-6f40c901993657d5cf2c0c32453fd969.png";